<script setup lang="ts">
import { defineProps } from "vue";
import {computedFontSize, paddingSize} from "/@/lib/font.ts";
defineProps({
  active: Boolean,
  text:String
});
</script>

<template>
  <div class="tab" :class="{ active: !active }">
    <div style="height: 4.5dvh"></div>

    <!-- 单独的文本区域 -->
    <div class="tab-text-container">
      <p class="tab-text" :class="{ active: active }" :style="{'fontSize':`${computedFontSize(text,2,6)}dvh`,'padding-top':`${paddingSize(computedFontSize(text,2,7))}dvh`}">{{text}}</p>
    </div>

    <!-- 其他内容保持原样 -->
    <div class="box" :class="{ active: !active }"></div>
    <div class="box1" :class="{ active: !active }"></div>
    <div class="bottom-box" :class="{ active: !active }"></div>
  </div>
</template>

<style scoped lang="scss">
$box-size: 1dvh;
$color1: #2B2B2B;
$color2: #FEDC27;
$color3: rgba(43, 43, 43, 0);
$tab-bg: #FDE638;

.tab {
  max-width: 200px;
  user-select: none;
  flex: 1;
  text-align: center;
  color: white;
  background: $tab-bg;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  margin: 0 0.5vw;
  height: 100%;
  opacity: 1; // 默认透明
  overflow: hidden;
  position: relative; // 让tab保持相对定位

  &.active {
    //opacity: 1;
    transition: background 0.2s ease;
    background: rgba(255, 255, 255, 0)
  }

  .tab-text-container {
    position: absolute; // 使用绝对定位确保文本区域不会影响其他内容
    top: 10px; // 可以根据需要调整顶部位置
    left: 50%;
    transform: translateX(-50%); // 水平居中
    z-index: 1; // 确保文本在其他内容之上
    width: 100%;
    text-align: center; // 确保文本居中对齐

  }

  //.tab-text {
  //  padding-top: 1dvh;
  //  font-size: 2vh;
  //  font-family: "wenfeng-mkzyt", sans-serif;
  //  color: #2b2b2b;
  //}
  .tab-text {
    //font-size: 2dvh;  /* 初始字体大小基于视口宽度 */
    font-family: "wenfeng-mkzyt", sans-serif;
    color: rgba(255, 255, 255, 0.8);
    white-space: nowrap;  /* 禁止换行 */
    overflow: hidden;  /* 隐藏溢出的部分 */
    text-overflow: ellipsis;  /* 超出部分显示省略号 */
    width: 100%;  /* 容器宽度可以根据需要调整 */
    &.active {
      color: #2b2b2b;
    }
  }

}

.back {
  user-select: none;
  display: flex;
  flex-direction: column; // 让子元素垂直排列
  justify-content: center; // 让子元素上下居中
  align-items: stretch; // 让子元素左右占满
  width: 100%;
  height: 8dvh;
  background: $color1;
}
.box {
  width: 100%;
  height: $box-size;
  background: repeating-linear-gradient(
          90deg,
          $color2 0px,
          $color2 $box-size,
          $color3 $box-size,
          $color3 2 * $box-size
  );
  &.active {
    background: rgba(255, 255, 255, 0)
  }
}

.box1 {
  width: 100%;
  height: $box-size;
  background: repeating-linear-gradient(
          90deg,
          $color3 0px,
          $color3 $box-size,
          $color2 $box-size,
          $color2 2 * $box-size
  );
  &.active {
    background: rgba(255, 255, 255, 0)
  }
}

.bottom-box {
  height: 100%;
  background-color: #FDCF17;
  &.active {
    background-color: rgba(255, 255, 255, 0)
  }
}
</style>
